import { newSpecPage } from '@stencil/core/testing'
import { CobaltTabsHorizontal } from '../cobalt-tabs-horizontal'

describe('cobalt-tabs-horizontal', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [CobaltTabsHorizontal],
      html: `
<cobalt-tabs-horizontal>
  <cobalt-tab-panel label="Tab 1" icon-name="star-outline">
  <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 2" disabled="true" icon-name="star-outline">
  <div class="custom-panel-content-class typography-body-medium-regular">Disabled panel</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 3" icon-name="star-outline">
  <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
  </cobalt-tab-panel>
</cobalt-tabs-horizontal>
`
    })
    expect(page.root).toEqualHtml(`
      <cobalt-tabs-horizontal>
        <div class="cobalt-tabs cobalt-tabs--horizontal" id="tabs-horizontal-0">
          <div class="list-header-wrapper">
            <cobalt-icon-button aria-hidden="" class="previous-button previous-button--hidden" iconname="chevron_left-outline" label="Précédent" variant="quaternary"></cobalt-icon-button>
            <div class="cobalt-tabs-list-header">
              <ul class="cobalt-tabs-list typography-monoline-medium" role="tablist">
                <li aria-controls="tabs-horizontal-0_tab-panel-0" aria-disabled="false" aria-selected="true" class="cobalt-tab-item tab-item--icon-left tab-item--selected" id="tab-label-0" role="tab" tabindex="0">
                  <div class="tab-label-content">
                    <div class="icon-box">
                      <cobalt-icon name="star-solid" size="number-size-icon-medium"></cobalt-icon>
                    </div>
                    <span class="tab-label">
                      Tab 1
                    </span>
                  </div>
                </li>
                <li aria-controls="tabs-horizontal-0_tab-panel-1" aria-disabled="true" aria-selected="false" class="cobalt-tab-item tab-item--disabled tab-item--icon-left" id="tab-label-1" role="tab" tabindex="0">
                  <div class="tab-label-content">
                    <div class="icon-box">
                      <cobalt-icon name="star-outline" size="number-size-icon-medium"></cobalt-icon>
                    </div>
                    <span class="tab-label">
                      Tab 2
                    </span>
                  </div>
                </li>
                <li aria-controls="tabs-horizontal-0_tab-panel-2" aria-disabled="false" aria-selected="false" class="cobalt-tab-item tab-item--icon-left" id="tab-label-2" role="tab" tabindex="0">
                  <div class="tab-label-content">
                    <div class="icon-box">
                      <cobalt-icon name="star-outline" size="number-size-icon-medium"></cobalt-icon>
                    </div>
                    <span class="tab-label">
                      Tab 3
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <cobalt-icon-button aria-hidden="" class="next-button next-button--hidden" iconname="chevron_right-outline" label="Suivant" variant="quaternary"></cobalt-icon-button>
          </div>
          <div class="tab-content">
            <div aria-labelledby="tab-label-0" id="tabs-horizontal-0_tab-panel-0" role="tabpanel" style="display: block;">
              <cobalt-tab-panel icon-name="star-outline" label="Tab 1" slot="tabs-horizontal-0_tab-0">
                <div class="custom-panel-content-class typography-body-medium-regular">
                  content 1
                </div>
              </cobalt-tab-panel>
            </div>
            <div aria-labelledby="tab-label-1" id="tabs-horizontal-0_tab-panel-1" role="tabpanel" style="display: none;">
              <cobalt-tab-panel disabled="true" icon-name="star-outline" label="Tab 2" slot="tabs-horizontal-0_tab-1">
                <div class="custom-panel-content-class typography-body-medium-regular">
                  Disabled panel
                </div>
              </cobalt-tab-panel>
            </div>
            <div aria-labelledby="tab-label-2" id="tabs-horizontal-0_tab-panel-2" role="tabpanel" style="display: none;">
              <cobalt-tab-panel icon-name="star-outline" label="Tab 3" slot="tabs-horizontal-0_tab-2">
                <div class="custom-panel-content-class typography-body-medium-regular">
                  content 3
                </div>
              </cobalt-tab-panel>
            </div>
          </div>
        </div>
      </cobalt-tabs-horizontal>
    `)
  })
})
